const STORAGE_KEY = 'cwoOnboardingTour';

// An armed tour left behind (the user wandered off mid-tour) would otherwise
// pop up unsolicited whenever a later stage's URL is visited in this session.
const STATE_TTL_MS = 60 * 60 * 1000;

export const activeTourState = () => {
  try {
    const state = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    if (!state) return null;

    if (Date.now() - state.armedAt > STATE_TTL_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return state;
  } catch {
    return null;
  }
};

export const setActiveTourState = (state) => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...state, armedAt: Date.now() }));
};

export const clearActiveTourState = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
